import {
    HOMEPAGE_DATA_REQUEST,
    HOMEPAGE_DATA_REQUEST_SUCCESS,
    HOMEPAGE_DATA_REQUEST_FAIL,
    ABOUT_DATA_REQUEST,
    ABOUT_DATA_REQUEST_SUCCESS,
    ABOUT_DATA_REQUEST_FAIL,
    CONTACT_DATA_REQUEST,
    CONTACT_DATA_REQUEST_SUCCESS,
    CONTACT_DATA_REQUEST_FAIL,
    CONTACT_REQUEST_FAIL,
    CONTACT_REQUEST,
    CONTACT_REQUEST_SUCCESS
} from './pageConstants'

export const homePageReducers = (state = {
    loading: true,
    articles: [],
    categories: [],
    newest: [],
    topSales: [],
}, action) => {
    switch (action.type) {
        case HOMEPAGE_DATA_REQUEST:
            return {
                loading: true,
                ...state
            }
        case HOMEPAGE_DATA_REQUEST_SUCCESS:
            return {
                loading: false,
                articles: action.payload.articles,
                categories: action.payload.categories,
                newest: action.payload.newest,
                topSales: action.payload.topSales,
            }
        case HOMEPAGE_DATA_REQUEST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const aboutPageReducers = (state = {
    aboutText: '',
    whySentences: '',
    faq: '',
    imgs: ''
}, action) => {
    switch (action.type) {
        case ABOUT_DATA_REQUEST:
            return {
                locading: true,
                ...state
            }
        case ABOUT_DATA_REQUEST_SUCCESS:
            return {
                locading: false,
                aboutText: action.payload.aboutText,
                whySentences: action.payload.whySentences,
                faq: action.payload.faq,
                imgs: action.payload.imgs
            }
        case ABOUT_DATA_REQUEST_FAIL:
            return { locading: false, error: action.payload }
        default:
            return state
    }
}

export const contactPageReducers = (state = {
    address: '',
    phoneNumbers: '',
    workTime: '',
    email: ''
}, action) => {
    switch (action.type) {
        case CONTACT_DATA_REQUEST:
            return {
                locading: true,
                ...state
            }
        case CONTACT_DATA_REQUEST_SUCCESS:
            return {
                locading: false,
                address: action.payload.address,
                phoneNumbers: action.payload.phoneNumbers,
                workTime: action.payload.workTime,
                email: action.payload.email
            }
        case CONTACT_DATA_REQUEST_FAIL:
            return { locading: false, error: action.payload }
        default:
            return state
    }
}

export const sendContactReducers = (state = {
    msg: '',
}, action) => {
    switch (action.type) {
        case CONTACT_REQUEST:
            return {
                locading: true,
                ...state
            }
        case CONTACT_REQUEST_SUCCESS:
            return {
                locading: false,
                msg: action.payload
            }
        case CONTACT_REQUEST_FAIL:
            return { locading: false, error: action.payload }
        default:
            return state
    }
}